module.exports = "/public/images/337a3b1d0945c777049cf917258e6347.svg";